module.exports = __webpack_public_path__ + "static/gallery3-66cf55db83c0e61be1abccbc851852f6.jpg";